export class UserRight {
  public fullView: boolean;
  public encodageToutService: boolean;
  public accesAdminSysteme?: boolean;
  public accesBackupDatabase?: boolean;
  public accesDossiersClassement?: boolean;
  public accesDossiersClassementPartiel?: boolean;
  public accesModuleDiv?: boolean;
  public accesModuleRn?: boolean;
  public accesModuleBce?: boolean;
  public accesContactUpdateRnTva?: boolean;
  public accesDoublonsContact?: boolean;
  public accesCourrier?: boolean;
  public accesContact?: boolean;
  public accesAdmin?: boolean;
  public accesModeleDocument?: boolean;
  public accesClassement?: boolean;
  public creationCourrierEntrant?: boolean;
  public creationCourrierSortant?: boolean;
  public accesCourrierHistorique?: boolean;
  public accesCourrierDroit?: boolean;
  public controleurQualiteScan?: boolean;
  public restrictiScanToParentService?: boolean;
  public accesDocumentACompleter?: boolean;
  public accesExpedition?: boolean;
  public limiterExpeditionService?: boolean;
  public limiterExpeditionDocument?: boolean;
  public accesCourrierOutil?: boolean;
  public accesEncodageRetourCourrier?: boolean;
  public accesArchivageMasseCourrier?: boolean;
}
